import { Box, Button, Chip, Divider, Typography } from '@mui/material';
import { useLiveMatch } from '../LiveMatchContext.tsx';

function formatDuration(ms: number): string {
  if (ms <= 0) return '';
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export default function SetEndSummaryScreen() {
  const { state, dispatch } = useLiveMatch();
  const last = state.completedSets[state.completedSets.length - 1];
  if (!last) return null;

  const winnerIsHome = last.homePoints > last.awayPoints;
  const winnerName  = winnerIsHome ? state.homeTeamName  : state.awayTeamName;
  const winnerColor = winnerIsHome ? state.homeShirtColor : state.awayShirtColor;
  const durationStr = formatDuration(last.durationMs);

  return (
    <Box
      sx={{
        height: '100%',
        bgcolor: '#1a1a2e',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2.5,
        color: 'white',
        p: 3,
      }}
    >
      <Typography sx={{ fontSize: { xs: '0.85rem', sm: '1.1rem' }, opacity: 0.4, letterSpacing: 3, textTransform: 'uppercase' }}>
        Set {last.setNumber} terminato
      </Typography>

      <Typography sx={{ fontSize: { xs: '3rem', sm: '5rem' }, fontWeight: 900, color: '#FFD700', lineHeight: 1 }}>
        {last.homePoints} – {last.awayPoints}
      </Typography>

      <Typography sx={{ fontSize: { xs: '1.1rem', sm: '1.6rem' }, fontWeight: 700, color: winnerColor }}>
        {winnerName} vince il set
      </Typography>

      {durationStr && (
        <Typography sx={{ opacity: 0.4, fontSize: '0.85rem' }}>
          Durata {durationStr}
        </Typography>
      )}

      <Divider sx={{ width: '50%', borderColor: 'rgba(255,255,255,0.12)', my: 0.5 }} />

      {/* Set vinti */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' }, fontWeight: 800 }}>
            {state.setsWon.home}
          </Typography>
          <Typography
            noWrap
            sx={{ opacity: 0.4, fontSize: '0.7rem', maxWidth: 90 }}
          >
            {state.homeTeamName}
          </Typography>
        </Box>
        <Typography sx={{ opacity: 0.3, fontSize: '1.5rem', fontWeight: 300 }}>–</Typography>
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' }, fontWeight: 800 }}>
            {state.setsWon.away}
          </Typography>
          <Typography
            noWrap
            sx={{ opacity: 0.4, fontSize: '0.7rem', maxWidth: 90 }}
          >
            {state.awayTeamName}
          </Typography>
        </Box>
      </Box>

      {/* Riepilogo set precedenti */}
      {state.completedSets.length > 1 && (
        <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', justifyContent: 'center' }}>
          {state.completedSets.map((s) => (
            <Chip
              key={s.setNumber}
              label={`Set ${s.setNumber}: ${s.homePoints}–${s.awayPoints}`}
              size="small"
              sx={{ bgcolor: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.55)', fontSize: '0.7rem' }}
            />
          ))}
        </Box>
      )}

      <Button
        variant="contained"
        size="large"
        onClick={() => dispatch({ type: 'START_NEW_SET' })}
        sx={{ mt: 1.5, fontWeight: 700, px: 5, fontSize: { xs: '0.9rem', sm: '1rem' } }}
      >
        Inizia Set {last.setNumber + 1} →
      </Button>
    </Box>
  );
}
